export function entries<T extends object>(
  obj: T,
): Array<[keyof T, T[keyof T]]> {
  return Object.entries(obj) as Array<[keyof T, T[keyof T]]>;
}

export function fromEntries<
  K extends PropertyKey,
  V,
  A extends readonly (readonly [K, V])[],
>(ent: A): { [P in A[number] as P[0]]: P[1] } {
  return Object.fromEntries(ent) as {
    [P in A[number] as P[0]]: P[1];
  };
}
